import { REGISTER_USER_SUCCESS, LOGIN_USER_SUCCESS, CLEAR_USER, LOGIN_AD_USER_SUCCESS, LOGOUT_SUCCESS, UNMOUNT_REGISTER_USER_SUCCESS, SET_COUNTRY, VERIFY_CAPTCHA_SUCCESS, GET_APP_SETTINGS_SUCCESS } from '../constants/constants';

export function UserAuthReducer(state = { registeredUser: {}, loggedInUser: {}, setCountry: 0, isCaptchaVerified: false, appSettings: {} }, action: any) {
  switch (action.type) {
    case REGISTER_USER_SUCCESS:
      return {
        ...state,
        registeredUser: action.payload.data
      }
    case LOGIN_USER_SUCCESS:
      return {
        ...state,
        loggedInUser: action.payload.data
      }
    case VERIFY_CAPTCHA_SUCCESS:
      return {
        ...state,
        isCaptchaVerified: action.payload.data.success
      }
    case GET_APP_SETTINGS_SUCCESS:
      return {
        ...state,
        appSettings: action.payload
      }      
    case CLEAR_USER:
      return {
        ...state,
        loggedInUser: {}
      }
    case LOGIN_AD_USER_SUCCESS:
      return {
        ...state,
        loggedInUser: action.payload.data
      }
    case LOGOUT_SUCCESS:
      return {
        ...state,
        loggedInUser: {}
      }
    case UNMOUNT_REGISTER_USER_SUCCESS:
      return {
        ...state,
        registeredUser: null
      }
    case SET_COUNTRY:
      return{
        ...state,
        setCountry: 1
    }
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/reducer.userAuth.tsx